import React from 'react';
import PropTypes from 'prop-types';
import { openLoginModal } from '~spa/Utils/WrapperIntegration/Ucf';
import NoResults from '~shared/ui/NoResults';
import { Trans } from 'react-i18next';
import { LOGIN_TEXT, LOGIN_TO_SEE_TEXT } from './constants';
import {
    useShouldHideLogin,
} from '~SpectateStore/hooks/userHooks';

const NotLoggedIn = ({textKey}) => {
    const shouldHideLogin = useShouldHideLogin();

    return (
        <NoResults
            buttonLabel={!shouldHideLogin ? <Trans i18nKey={LOGIN_TEXT} /> : false}
            onButtonClick={openLoginModal}
        >
            <Trans i18nKey={textKey || LOGIN_TO_SEE_TEXT} />
        </NoResults>
    );
};

NotLoggedIn.propTypes = {
    textKey: PropTypes.string,
};

export default NotLoggedIn;
